import React from "react";
import _ from "lodash";
import { WithStyles, withStyles, createStyles } from "@material-ui/core";
import config from "../../config/config";
import "mathlive_jodit/build/bundle.css";
import { SectionFocusedContextValue } from "./MyPATBaseSection";
import classNames from "classnames";

const styles = () =>
  createStyles({
    transparentBorder: {
      border: "1px solid transparent",
      borderRadius: 6,
      "& .jodit_workplace": {
        border: "1px solid transparent",
      },
    },
    focusedBorder: {
      border: "1px solid #1D7DEA !important",
      borderRadius: 6,
      backgroundColor: "#FAFCFF",
      "& .jodit_workplace": {
        border: "1px solid #1D7DEA !important",
        borderRadius: 6,
      },
      "& .jodit_container": {
        // border: "1px solid #1D7DEA !important",
        borderRadius: 6,
      },
    },
    labels: {
      color: "#7f7f7f",
      marginBottom: '5px'
    },
    textEditor: {
      width: "100%",
      padding: "0.5rem 0",
    },
  });

const getDataTransfer = (
  event: ClipboardEvent | DragEvent
): DataTransfer | null => {
  if ((event as ClipboardEvent).clipboardData) {
    return (event as ClipboardEvent).clipboardData;
  }

  return (event as DragEvent).dataTransfer || new DataTransfer();
};

export interface MyPATMathEditorProps extends WithStyles<typeof styles> {
  externalToolbarId: string;
  name: string;
  value: string | number;
  editorId: string;
  handleChange: Function;
  setInstance: Function;
  select: any;
  placeholder: any;
  editorProps: any,
  actualPlaceholder: string,
  actualLabel: string,
  setSectionFocus: SectionFocusedContextValue["setSectionFocus"];
}

interface MyPATMathEditorState {
  setChangedValue: boolean;
  str: "";
  isFocused: boolean;
  // charLeft: any
}

class MyPATMathEditor extends React.PureComponent<
  MyPATMathEditorProps,
  MyPATMathEditorState
> {
  editorInstance: any = null;
  interval: any;
  myRef: any;
  // maxChars = 1000;
  public static defaultProps = {
    placeholder: "Add Text here",
  };
  constructor(props: MyPATMathEditorProps) {
    super(props);
    this.state = {
      setChangedValue: true,
      str: "",
      isFocused: false,
      // charLeft: this.maxChars
    };
    //@ts-ignore
    this.myRef = React.createRef();
  }

  componentDidMount() {
    const {
      editorId,
      name,
      handleChange,
      externalToolbarId,
      value,
      setSectionFocus,
    } = this.props;


    const MathLiveJodit = new Promise((res) => {
      const editor = require("mathlive_jodit/build/js/matheditor.min")
      res(editor)
    })

    MathLiveJodit.then((Editor: any) => {
      if (!this.myRef.current) {
        return;
      }
      this.editorInstance = Editor.init(this.myRef.current, {
        events: {
          change: (value: string) => {
            // console.log(':::::::::::;editorInstance:::::::::::',this.editorInstance && this.editorInstance.value())
            let changedValue = "";
            if (this.editorInstance) {
              changedValue = this.editorInstance.value() || "";
            }
            // setting init value from editor handleChnage should be skiped in this case
            if (value === "<p> </p>" || value === "<p> <br></p>") {
              return "";
            }
            handleChange({
              target: {
                name,
                value: changedValue,
              },
            });
            // if (this.state.charLeft > 0) {
            // 	this.setState({
            // 		charLeft: this.maxChars - this.editorInstance.jodit.editor.innerText.length
            // 	});
            // }
          },
          focus: () => {
            this.setState({ setChangedValue: false, isFocused: true });

            this.editorInstance.toolbarInExternalId(externalToolbarId);
            setSectionFocus(true);
          },
          beforePaste: (event: ClipboardEvent | DragEvent) => {
            // const dt = getDataTransfer(event);
            // console.log({dt});
            //             if (dt) {
            //               const types: ReadonlyArray<string> | string = dt.types;
            //               const items=dt.items;
            //               // const items:any []=dt.items;
            //               // console.log(items);
            //               // if(Array.isArray(items)){
            //               //   console.log("asd");
            //               //    const isImage=items.find((item)=>item.kind=='file');
            //               //    if(isImage)
            //               //     return true;
            //               // }else{
            // //               kind: "file"
            // // type: "image/png"
            //               let types_str: string = "";

            //               if (Array.isArray(types)) {
            //                 for (let i = 0; i < types.length; i += 1) {
            //                   types_str += types[i] + ";";
            //                 }
            //               } else {
            //                 types_str = types.toString() + ";";
            //               }

            //               const str = String.raw`${dt.getData("text/plain")}`;
            //               console.log({str});
            //               this.editorInstance.joditSelfInfo = this.editorInstance.jodit.selection.save();
            //               this.editorInstance.latexWorkplace = { value: str };
            //               this.editorInstance.addLatexToJodit();
            //               return false; 
            //              }
          },
          blur: () => {
            this.setState({ setChangedValue: true, isFocused: false });
            setSectionFocus(false);
          },
          beforeOpenPasteDialog: (msg: any, title: any, callback: Function) => {
            // setTimeout(() => {
            //   //@ts-ignore
            //   // @hack
            //   $ && $(".jodit_dialog_box").remove();
            //   callback(0);
            // }, 0);
          },
          // processPaste:()=>{
          //      console.log('processPasteHTML');
          // }
          paste: () => {
            console.log('qwert');
          }
        },
        uploader: { insertImageAsBase64URI: true },
        ImageUploaderPath: `${config.baseURL
          }/content/question/image/${getAuthToken()}`,
        toolbar: document.getElementById("box"),
        tabIndex: 0,
        processPasteHTML: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        processPasteFromWord: false,
      });
      this.props.setInstance(this.editorInstance);
      // @hack adding toolbar in external id
      this.editorInstance.toolbarInExternalId(this.props.externalToolbarId);

      if (this.props.value) {
        this.editorInstance.value(this.props.value);
      }
    })
  }

  componentDidUpdate(prevProps: MyPATMathEditorProps) {
    if (this.editorInstance) {
      
      // update value on load for old and new field
      if (
        this.state.setChangedValue &&
        !_.isEqual(prevProps.value, this.props.value) &&
        !_.isEqual(this.editorInstance.value(), this.props.value)
      ) {
        if (!_.isEmpty(this.props.value)) {
          this.editorInstance.value(this.props.value);
          
        } else {
          // this.editorInstance.value('<p> </p>');
        }
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    const { isFocused } = this.state;
    const { classes, placeholder, actualPlaceholder, actualLabel } = this.props;
    return (
      // this.props.name === 'theoryDescription' ? <div className='wrapper' draggable={false} style={{ position: "relative" }}>
      // 	<textarea ref={this.myRef} className='mypat-editor' placeholder={this.props.placeHolder} draggable={false} id={this.props.editorId} maxLength={1000} rows={3} cols={3}></textarea>
      // 	<span style={{ textAlign: 'right', position: 'absolute', bottom: '5px', right: '10px', color: "gray" }}>{`${this.state.charLeft}/${this.maxChars}`}</span>
      // </div>
      // 	:
      <>
      <div>
        {actualLabel && (<div className={classes.labels}>{actualLabel}</div>)}
      </div>
      <div
        className={classNames(
          "wrapper",
          classes.transparentBorder,
          isFocused && classes.focusedBorder
        )}
        draggable={false}
      >
        <textarea
          placeholder={actualPlaceholder || placeholder}
          ref={this.myRef}
          className={classNames("mypat-editor", classes.textEditor)}
          draggable={false}
          id={this.props.editorId}
          rows={3}
          cols={3}
        />
      </div>
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(MyPATMathEditor);

const getAuthToken = function() {
  let store: any = localStorage.getItem(config.localStorageKey);
  store = JSON.parse(store);
  let token = store.authenticatedUser.token;
  token = !token ? store.authenticatedUser.authToken : token;
  return `${token}`;
};
